// AboutSection.js
import React from 'react';

const AboutSection = () => {
  return (
    <section className="about-section">
      <h2 className="section-title">About Me</h2>
      <div className="underline"></div>
      
      <p className="about-text">
        Hello! I'm Jun, an aspiring IT professional with a passion for creating innovative solutions. Studying Computer Science has shaped my problem-solving abilities and deepened my understanding of technology. Through courses in algorithms, software engineering, and networking, I have built a strong technical foundation while also improving my ability to collaborate and adapt. My passion for learning extends beyond academics, as I continuously explore new technologies and apply my knowledge to real-world challenges.
      </p>
      
      <p className="about-text">
      My experience as a Student System and Network Administrator has reinforced my technical expertise and problem-solving skills. Managing IT infrastructure, assisting users, and working with automation tools have given me valuable hands-on experience. My IT internship further strengthened my ability to adapt and innovate in fast-paced environments, fueling my passion for technology and its real-world applications.








      </p>
    </section>
  );
};

export default AboutSection;